// This module must be imported before any other module that defines Zod schemas.
// Zod 4 uses JIT compilation (via new Function()) by default, which triggers
// CSP unsafe-eval violations. Disabling JIT here prevents the probe from firing
// during schema registration.
// Tracking resolution in https://github.com/colinhacks/zod/issues/5789
import { z } from "zod";

z.config({ jitless: true });

// Zod's entry module installs its English messages with a top-level
// `config(en())` call, but its package.json declares `"sideEffects": false`,
// so the production build drops that call and every issue reads "Invalid
// input". Installing the locale here keeps messages such as "Too small:
// expected string to have >=1 characters".
z.config(z.locales.en());
